var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"100px"}},[_vm._v(" Contact tech support here ")])}
var staticRenderFns = []

export { render, staticRenderFns }